import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "localization"
    }}>{`Localization`}</h1>
    <p>{`Violin has a simple localization module. It was built with React Context and it is as easy to use as any other React Context implementation.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { LocalizationContext } from "@involves/violin";

const App = () => {
  return (
    <>
      <GlobalStyle />
      <LocalizationContext value={customLocale}>
        { /** Violin components goes down here in the tree */ }
      </LocalizationContext>
    </>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "locale-object"
    }}>{`Locale Object`}</h2>
    <p>{`You can find the default locale object `}<a parentName="p" {...{
        "href": "https://github.com/involvestecnologia/violin/blob/asyncawait/innovation/localization/src/lib/localization/defaultLocale.js"
      }}>{`here!`}</a></p>
    <p>{`As for now it is really simple:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const defaultLocale = {
  Select: {
    noOptionsText: 'Sem opções',
  }
}
`}</code></pre>
    <p>{`And you can use it like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { LocalizationContext } from "@involves/violin";

const customLocale = {
  Select: {
    noOptionsText: 'Custom message',
  }
}

const App = () => {
  return (
    <>
      <GlobalStyle />
      <LocalizationContext value={customLocale}>
        { /** Violin components goes down here in the tree */ }
      </LocalizationContext>
    </>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      